<script>
	import { pageOffset, topNavigationOpened, isPortraitScreen } from '../js/model/stores';
	import { animateElement } from '../js/utils/animate';
	import TopNavigationHearts from "./elements/TopNavigationHearts.svelte";
	import TopNavigationLogo from "./elements/TopNavigationLogo.svelte";
	import TopNavigationLinks from "./elements/TopNavigationLinks.svelte";
	import TopNavigationImplementers from "./elements/TopNavigationImplementers.svelte";

	let _nav;
	let portrait;

	export let route;
	export let animate = true;

	let animation = (value) => {
		if (value > window.innerHeight * (portrait ? 0.9 : 1.2)) {
			_nav.style.opacity = 1;
			_nav.style.pointerEvents = 'auto';
		} else {
			_nav.style.opacity = 0;
			_nav.style.pointerEvents = 'none';
			_nav.classList.remove('top_navigation--opened-true');
			_nav.classList.add('top_navigation--opened-false');
		}
	};

	function runAnimation() {
		if (!_nav) {
			return;
		}
		_nav.classList.remove('top_navigation--opened-true');
		_nav.classList.remove('top_navigation--opened-false');
		// This line is needed, to rerun the animation!!!
		void _nav.offsetWidth;
		topNavigationOpened.set(!$topNavigationOpened);
		_nav.classList.add('top_navigation--opened-' + $topNavigationOpened);
	}

	let prepareScene = () => {
		if(!animate) {
			return;
		}
		if (!_nav) {
			requestAnimationFrame(prepareScene);
			return;
		}

		_nav.style.opacity = 0;
		isPortraitScreen.subscribe((state) => {
			portrait = state;
		});
		pageOffset.subscribe(animation);
	};

	prepareScene();
</script>

<style>
	.top_navigation {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		z-index: 30;
		opacity: 0;
		transition: opacity 1s;
	}

	.top_navigation__content {
		position: relative;
		background-color: #ebc851ff;
		height: 4em;
		transition: height .5s;
		overflow: hidden;
	}

	.links-container {
		top: calc(40vh + 4em);
		position: absolute;
		left: 50%;
		transform: translateX(-50%) translateY(-60%);
		height: 0;
	}

	:global(.top_navigation__content ul) {
		margin: 0;
		padding: 0;
		list-style: none;
	}

	.wave {
		width: 101vw; /* or else Safari will show small gaps left and right */
		margin-top: -1px;
		display: block;
	}

	.wave.portrait {
		display: flex;	/* else we have a large gap towards the top_navigation__content on mobile devices */
	}

	:global(.top_navigation svg) {
		width: 100%;
		height: auto;
	}

	:global(.top_navigation--opened-true .top_navigation__content) {
		height: 100vh;
	}
	:global(.top_navigation--opened-true .links-container) {
		height: unset;
	}
</style>
<div class="top_navigation" bind:this={_nav} on:click={() => route === 'home'? runAnimation() : false}>
	<div class="top_navigation__content">
		<TopNavigationHearts/>
		<TopNavigationLogo/>
		{#if route === 'home'}
			<div class="links-container">
				<TopNavigationLinks/>
				<TopNavigationImplementers/>
			</div>
		{/if}
	</div>
	<div class:portrait class="wave">
		<svg width="1440" height="31" version="1.1" viewBox="0 0 1440 31" xmlns="http://www.w3.org/2000/svg">
			<path d="m1440-70.9v79.9c-79.5 11.1-165 22-352.8 22-219.2 0-518-31-748-31-134 0-270.7 9.1-339.2 18.9v-89.8z" fill="#ebc851"/>
			<path d="m1440 0v9c-79.5 11.1-165 22-352.8 22-219.2 0-518-31-748-31-134 0-270.7 9.1-339.2 18.9v-18.9z" fill="#ebc851"/>
		</svg>
	</div>
</div>
